<template>
  <AnalyticsWidget
    title="Accounts Summary"
    subTitle="Summary data for accounts"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Invoices"
              :value="summaryData.todayInvoiceAmount">
              {{formatCurrency(summaryData.todayInvoiceAmount)}}
              <template v-slot:info>In {{summaryData.todayInvoiceCount}} invoice{{displayCountPlural(summaryData.todayInvoiceCount)}} created today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Average Daily Invoice Total"
              :value="summaryData.averageDailyInvoiceAmount">
              {{formatCurrency(summaryData.averageDailyInvoiceAmount)}}
              <template v-slot:info>Average of {{formatInteger(summaryData.averageDailyInvoiceCount)}} invoice{{displayCountPlural(summaryData.averageDailyInvoiceCount)}} created daily for {{currentMonthName}}</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Payments"
              :value="summaryData.todayPaymentAmount">
              {{formatCurrency(summaryData.todayPaymentAmount)}}
              <template v-slot:info>In {{summaryData.todayPaymentCount}} payment{{displayCountPlural(summaryData.todayPaymentCount)}} made today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Average Daily Payment Total"
              :value="summaryData.averageDailyPaymentAmount">              
              {{formatCurrency(summaryData.averageDailyPaymentAmount)}}
              <template v-slot:info>Average of {{formatInteger(summaryData.averageDailyPaymentCount)}} payment{{displayCountPlural(summaryData.averageDailyPaymentCount)}} made daily for {{currentMonthName}}</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Cash Payments"
              :value="todayPaymentValue(PaymentTypes.cash)">
              {{formatCurrency(todayPaymentValue(PaymentTypes.cash))}}
              <template v-slot:info>In {{todayPaymentCount(PaymentTypes.cash)}} cash payment{{displayCountPlural(todayPaymentCount(PaymentTypes.cash))}} made today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Credit Card Payments"
              :value="todayPaymentValue(PaymentTypes.creditCard)">
              {{formatCurrency(todayPaymentValue(PaymentTypes.creditCard))}}
              <template v-slot:info>In {{todayPaymentCount(PaymentTypes.creditCard)}} credit card payment{{displayCountPlural(todayPaymentCount(PaymentTypes.creditCard))}} made today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Direct Debit Payments"
              :value="todayPaymentValue(PaymentTypes.EFTPOS)">
              {{formatCurrency(todayPaymentValue(PaymentTypes.EFTPOS))}}
              <template v-slot:info>In {{todayPaymentCount(PaymentTypes.EFTPOS)}} direct debit payment{{displayCountPlural(todayPaymentCount(PaymentTypes.EFTPOS))}} made today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Cheque Payments"
              :value="todayPaymentValue(PaymentTypes.cheque)">
              {{formatCurrency(todayPaymentValue(PaymentTypes.cheque))}}
              <template v-slot:info>In {{todayPaymentCount(PaymentTypes.cheque)}} cheque payment{{displayCountPlural(todayPaymentCount(PaymentTypes.cheque))}} made today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's External Payments"
              :value="todayPaymentValue(PaymentTypes.external)">
              {{formatCurrency(todayPaymentValue(PaymentTypes.external))}}
              <template v-slot:info>In {{todayPaymentCount(PaymentTypes.external)}} external payment{{displayCountPlural(todayPaymentCount(PaymentTypes.external))}} made today</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

import { PaymentTypes } from '@/store/types'

export default {
  name: 'AccountsSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    filter: Object,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    currentMonthName() {
      return moment().local().format('MMMM')
    }
  },
  data() {
    return {
      loading: true,
      summaryData: {},
    }
  },
  watch: {
    filter: function() {
      this.requestData()
    }
  },
  created() {
    this.PaymentTypes = PaymentTypes
  },
  mounted() {
    this.loading = true
    this.requestData()
  },
  methods: {
    requestData() {
      var params = {
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
      }

      this.$apiService.analyticsService.getAccountsSummary(params)
      .then(response => {
        this.summaryData = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    getTodayPaymentByType(type) {
      return (this.summaryData.todayPaymentTypeList || []).filter(paymentInfo => paymentInfo.paymentType == type)
    },
    todayPaymentValue(type) {
      return this.getTodayPaymentByType(type).reduce((curValue, paymentInfo)  => curValue + paymentInfo.totalPaymentAmount, 0)
    },
    todayPaymentCount(type) {
      return this.getTodayPaymentByType(type).reduce((curValue, paymentInfo)  => curValue + paymentInfo.totalPaymentCount, 0)
    }   
  }
}
</script>